<template>
  <div
    v-if="visible"
    class="modal fade show d-block"
    style="background: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">訂單出庫</h5>
          <button type="button" class="btn-close" @click="$emit('close')">
            X
          </button>
        </div>
        <div class="modal-body">
          <div v-if="order" class="mb-3">
            <div><strong>訂單編號：</strong> {{ order.order_number }}</div>
            <div><strong>收件人：</strong> {{ order.recipient_name }}</div>
            <div>
              <strong>商品數量：</strong> {{ order.items?.length || 0 }} 項
            </div>
          </div>
          <div class="form-group">
            <label>備註</label>
            <textarea class="form-control" v-model="notes" rows="3"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="$emit('close')"
          >
            取消
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="handleOutbound"
            :disabled="loading"
          >
            {{ loading ? "處理中..." : "確認出庫" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "OutboundModal",
  props: {
    visible: Boolean,
    orderId: [String, Number],
  },
  data() {
    return {
      order: null,
      notes: "",
      loading: false,
    };
  },
  watch: {
    visible(val) {
      if (val && this.orderId) {
        this.fetchOrder();
      }
    },
  },
  methods: {
    async fetchOrder() {
      try {
        const response = await request.get(`/api/admin/orders/${this.orderId}`);
        this.order = response.data.data || response.data;
      } catch (error) {
        console.error("Failed to fetch order", error);
        this.$emit("error", "無法載入訂單資訊");
      }
    },
    async handleOutbound() {
      this.loading = true;
      try {
        await request.post("/api/admin/inventory/outbound", {
          order_id: this.orderId,
          notes: this.notes,
        });
        this.$emit("success", "訂單出庫成功");
        this.$emit("close");
        this.notes = "";
      } catch (error) {
        console.error("Failed to process outbound", error);
        this.$emit("error", error.response?.data?.message || "出庫失敗");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
